/** @description Размер стрелок
 * EArrowsSize.LARGE Большие (полноэкранный режим)
 * EArrowsSize.NORMAL Обычные
 */
export var EArrowsSize;

/** @description Тип размера элемента
 * EWidthType.PIXEL Значение задано в пикселях
 * EWidthType.PERCENT Значение задано в процентах относительно элементов заданных этим же типом
 */
(function (EArrowsSize) {
  EArrowsSize[EArrowsSize["LARGE"] = 0] = "LARGE";
  EArrowsSize[EArrowsSize["NORMAL"] = 1] = "NORMAL";
})(EArrowsSize || (EArrowsSize = {}));
export var ESizeType;

/** @description Тип контрола карусели
 * EControlType.ARROWS Стрелки для переключения слайдов
 * EControlType.COUNTER Счетчик числа слайдов
 */
(function (ESizeType) {
  ESizeType[ESizeType["PIXEL"] = 0] = "PIXEL";
  ESizeType[ESizeType["PERCENT"] = 1] = "PERCENT";
})(ESizeType || (ESizeType = {}));
export var EControlType;

/** @description Интерфейс ширины элемента
 * @param {number} width Значение ширины элемента
 * @param {ESizeType} type Тип ширины элемента
 */
(function (EControlType) {
  EControlType[EControlType["ARROWS"] = 0] = "ARROWS";
  EControlType[EControlType["COUNTER"] = 1] = "COUNTER";
})(EControlType || (EControlType = {}));